module.exports = __webpack_public_path__ + "img/SketchPng88c5306c676a45ec85d922cf15ee2d1102c0bea17f9cca7708f56da10d64d977.f00889a9.png";